// extracted by mini-css-extract-plugin
module.exports = {"Slide":"OpenPositionSlide-module--Slide--3SlRI","SlideTitle":"OpenPositionSlide-module--SlideTitle--3O1fo"};